import { useFocusCustomers } from 'api/company/useFocusCustomers'
import { MainPage } from 'components/templates/MainPage'
import { FocusCustomerCard } from './FocusCustomerCard'

export const FocusCustomersPage = (): JSX.Element => {
  const { data, mutate } = useFocusCustomers()

  return (
    <MainPage>
      <div className={'space-y-5'}>
        <div className={'grid grid-cols-1 gap-4 xl:grid-cols-2'}>
          {data.length === 0 ? (
            <p className={'col-span-2 py-16 text-center text-sm text-gray-400'}>
              注力顧客はありません。タスク管理から会社を設定してください。
            </p>
          ) : (
            data.map((customer) => (
              <FocusCustomerCard
                key={customer.companyId}
                customer={customer}
                onRefresh={() => void mutate()}
              />
            ))
          )}
        </div>
      </div>
    </MainPage>
  )
}
